var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('span',[_vm._v("智慧城市车辆静态交通运管服务平台")])])
}]

export { render, staticRenderFns }